import { render } from "./password-legend.vue?vue&type=template&id=16c71ed1&ts=true"
import script from "./password-legend.vue?vue&type=script&lang=ts"
export * from "./password-legend.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__